import { Base } from '@studiometa/js-toolkit';
import { Accordion } from '@studiometa/ui';
import ProductStickyAddToCart from './ProductStickyAddToCart.js';
import Buybox from './Buybox.js';

/**
 * Product Component
 *
 */
export default class Product extends Base {
  static config = {
    name: 'Product',
    components: {
      Buybox,
      ProductStickyAddToCart,
      Accordion,
    },
  };
}
